import { useEffect, useRef, useState } from "react"
import { useSnapshot } from "valtio"
import { AgSelect } from "../components/AgComponents"
import { AgmodalStore, bookingsStore, breadCrumbStore, configStore, EntityV2Store, loginStore } from "../state/CommonState"
import Utils from "../util/Utils"
import TaskDatetime from "./task-datetime"
import Tasklistsmall from "./task-list-small"
import TaskStatusList from "./task-status-list"
import { taskStore } from "./task-store"
import Taskapi, { Task } from "./tasks-api"
import { getAction, getActionList, getActionListNames, getComponent } from "./tasks-static-data"
import { IconButton } from "@mui/material"
import backarrow  from "../assets/images/backarrow.svg";
import MonApi from "../state/mongo-api"

export default function TaskContainer(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    const [otherActions, setOtherActions] = useState([])
    const [openPending, setOpenPending] = useState(true)
    const [openStatus, setOpenStatus] = useState(false)
    const [branch,setBranch] = useState('')
    const [relationManager,setRelationManager] = useState('')
    const [customerService,setCustomerService] = useState('')
    const [shippingBillNumber,setShippingBillNumber] = useState('')
    let activeStyle = { backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR, color: 'white', border: `1px solid ${process.env.REACT_APP_ENTERPRISE_COLOUR}` }
    let inactiveStyle = { backgroundColor: '#bbbbbb', color: 'white', border: '1px solid #bbbbbb' }
    let pendingStyle = inactiveStyle
    let completedStyle = inactiveStyle
    if (openPending === true) pendingStyle = activeStyle
    else completedStyle = activeStyle
    let active = 'none'
    if (loginStore.isClient() && taskStore.myActionVisible) active = 'block'
    if (!loginStore.isClient() && AgmodalStore.pageVisible) active = 'block'
    let task = taskStore.current
    let firstCalled = useRef(1)
    if(task?.actionName?.includes('Raise Invoice')){
        task.actionName = task.actionName.split('(')[0]
    }else if(task?.actionName?.includes('Invoice Acceptance')){
        task.actionName = task.actionName.split('(')[0]
    }
    let action = getAction(task.actionName)
    let Comp = action?.component
    const getActionName = (action)=>{
    if(action.actionName == 'Raise Invoice'){
        return `Raise Invoice(${action.files[0].label})`
    }else if (action.actionName == 'Invoice Acceptance'){
        return `Invoice Acceptance(${action.files[0].label})`
    }else{
        return action.actionName
    }
    }
    console.log('GOT COMPONENT=', Comp)
    useEffect(() => {
        let f = async () => {
            let ret = await Taskapi.getTasklist4Booking(task.bookingNum)
            console.log('RESULT OF BOOKINGS ACTIONS=', ret)
            if (loginStore?.isClient())
                ret = ret.filter(e => task._id.num !== e._id.num && e.customerStatus === 'PENDING')
            else
                ret = ret.filter(e => task._id.num !== e._id.num && e.status === 'PENDING')
            setOtherActions(ret)
        }
        f()
        let getBranchName = async (branchId)=>{
            const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/list/branches/${task.entityId}`)            
            const b = data.results.filter((x,i) => x.branchId === branchId)
            setBranch(b[0].state)
        }
        getBranchName(task.branchId)

        let getRMName = async ()=>{
        const entityList = EntityV2Store.list.filter((e) => e.entityId === task.entityId)
        if(entityList[0]?.customer?.crossBorder?.relationshipManager){
        const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${entityList[0].customer?.crossBorder?.relationshipManager}`)  
        setRelationManager(data?.firstName+" "+data?.lastName+"("+data.email+','+data?.phone+")")
        }
    }
        getRMName()

        let getCSName = async ()=>{
        const entityList = EntityV2Store.list.filter((e) => e.entityId === task.entityId)
        if(entityList[0]?.customer?.crossBorder?.customerService){
        const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${entityList[0].customer?.crossBorder?.customerService}`)  
        setCustomerService(data?.firstName+" "+data?.lastName+"("+data.email+','+data?.phone+")")
        } 
    }
        getCSName()

    let getShippingBillNumber = async ()=>{
                  const data = await MonApi.find('Bookingdsr', {_id:task.bookingNum},{})
                  console.log(data[0],"data98765");
                  const obj = data[0]
                  setShippingBillNumber(Object.keys(obj)
                    ?.filter(key => key.startsWith("exportClearance")) 
                    ?.flatMap(key => obj[key]
                            ?.filter(item => item.label === "Shipping Bill Number" && item.value != '') 
                            ?.map(item => item.value))  
                    .join(", "))
                }
                getShippingBillNumber()
    }, [taskStore.current])
    const showdest = (key) =>{
        console.log(key)
        if(task[key]!=undefined && task[key].length>0){
            return <>
            <hr style={{margin:"0px"}}/>
            {task[key]}
            </>
        }
    }

    useEffect(()=>{
        if(firstCalled.current > 1){
            if (taskStore.previous) {
                taskStore.current = taskStore.previous
                taskStore.previous = null
            }
            taskStore.myActionVisible = false
            taskStore.isViewAll = false
            breadCrumbStore.back();
        }
        firstCalled.current += 1;
    },[configStore.currentSelectedEntity,configStore.currentSelectedBranch])

    useEffect(()=>{
     return ()=>{
        taskStore.myActionVisible = false;
        taskStore.isViewAll = false
     }
    },[])
    useEffect(()=>{
        if(taskStore.current!=undefined && taskStore.current.actionName!=undefined && taskStore.current.actionName.trim().length != 0 && taskStore.current.actionName!= taskStore.name){
            taskStore.name = taskStore.current.actionName
            taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
        }
        if(taskStore.name.trim().length>0 && taskStore.name==taskStore.current.actionName){
            taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
        }
    },[JSON.stringify(taskStore.current)])
    return (
        <div className="box" style={{ display: active, width: '100%',flex:1,overflow:"auto"}}>
            <div >
                <div style={{ height: '70vh' }}>
                    <div className="columns">
                        <div className="column is-7">
                            <div  style={{display:"flex",flexDirection:"row",gap:1,alignItems:"center"}}>
                                {loginStore.isClient() && 
                                // taskStore.isViewAll  && 
                                
                                <IconButton disableRipple onClick={()=>{
                                    if (taskStore.previous) {
                                        taskStore.current = taskStore.previous
                                        taskStore.previous = null
                                    }
                                    taskStore.myActionVisible = false
                                    taskStore.isViewAll = false
                                    breadCrumbStore.back();
                               }}>
                                   <img src={backarrow}/>
                               </IconButton>
                                }
                                  <h5 className="title is-4" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                                {getActionName(task)}
                            </h5>
                            </div>
                            <div className="box">
                                <tr>
                                    <td><strong>Booking ID</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{task.bookingNum}</td>
                                </tr>
                                { !loginStore.isClient() ?<>
                                  <tr>
                                    <td><strong>Customer Name</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{EntityV2Store.getEntityById(task.entityId).map(item => item.split('-')[0].trim())[0]}</td>
                                </tr>
                                <tr>
                                    <td><strong>Branch Name</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{branch}</td>
                                </tr>

                                {relationManager&&<tr>
                                    <td><strong>Relationships Manager</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{relationManager}</td>
                                </tr>}
                                {customerService&&<tr>
                                    <td><strong>Customer Service</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{customerService}</td>
                                </tr>}
                                {shippingBillNumber && <tr>
                                    <td><strong>Shipping Bill Number</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{shippingBillNumber}</td>
                                </tr>
                                }</>:<></>
                                }
                                <tr>
                                    <td>{task.origin}</td>
                                    <td style={{ fontSize: '1.2rem', fontWeight: 'bold' }}> &#8594; </td>
                                    <td>
                                        {task.destination}
                                        {showdest("destination2")}
                                        {showdest("destination3")}
                                        {showdest("destination4")}
                                        {showdest("destination5")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{task.shipmentType}</td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{task.shipmentScope}</td>
                                </tr>
                                {
                                    (task.dueDate) ?
                                        <tr>
                                            <td>Due Date & Time</td>
                                            <td style={{ width: '20px' }}></td>
                                            <td>{Utils.formatToDateTime1(task.dueDate, task.dueTime)}</td>
                                        </tr>
                                        : <></>
                                }
                            </div>
                            {
                                (!loginStore.isClient() && task.pendingWith === 'CUSTOMER') ? <>
                                    <button style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR, }} className="button is-link" onClick={() => {
                                        Taskapi.sendActionTriggerEmail()
                                        taskStore.setModalMessage('Email send successfully')
                                    }}>
                                        Retrigger Mail
                                    </button>&nbsp;&nbsp;
                                </> : <>

                                </>
                            }

                        </div>
                        <div className="column is-5">
                            {!loginStore.isClient()&&AgmodalStore.modalPage!='TaskContainer'?<button style={{ float: 'right' }} className="button is-small islink"
                                onClick={async (e) => taskStore.triggerActionVisible = false}>
                                <span className="icon ">
                                    <i className="fas fa-xmark"></i>
                                </span>
                            </button>:<></>}
                            <hr />

                            <div>
                                {/* {
                                (!loginStore.isClient())?<>
                            <button className="button is-link" onClick={()=>{
 Taskapi.sendActionTriggerEmail()
 taskStore.setModalMessage('Email send successfully')
                            }}>
                                Retrigger Mail
                            </button>&nbsp;&nbsp;
                            </>:<>

</>
} */}
                                {/* <button className="button is-link" onClick={()=> {
                            if (openStatus) setOpenStatus(!openStatus)
                            setOpenPending(!openPending)
                        }} >
                                Pendings
                            </button>&nbsp;&nbsp; */}
                                {/* <button className="button is-link" onClick={()=> {
                                if (openPending) setOpenPending(!openPending)
                                setOpenStatus(!openStatus)
                            }} >
                                Status
                            </button> */}
                            {
                                (loginStore.isClient())?<div>
                                <button className="button is-link"  style={{backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR}} onClick={()=> {
        setOpenPending(!openPending)
    }} >
                                    Pendings
                                </button>
                                </div>:<div className="column is-6" style={{ width: "100%" }} >
                                    <span >
                                        <button className="button is-small"
                                            onClick={() => {
                                                if (openStatus)
                                                    setOpenStatus(!openStatus)
                                                setOpenPending(true)
                                            }}
                                            style={{
                                                borderRadius: '25px 0px 0px 25px', width: "50%",
                                                ...pendingStyle
                                            }}>Pendings</button>
                                    </span>
                                    <span>
                                        <button className="button is-small"
                                            onClick={() => {
                                                if (openPending) setOpenPending(!openPending)
                                                setOpenStatus(true)
                                            }}
                                            style={{
                                                borderRadius: '0px 25px 25px 0px', width: "50%",
                                                ...completedStyle
                                            }}>Status</button>
                                    </span>
                                </div>
                            }
                                
                            </div>


                            <hr />
                            {
                                (openPending ? <Tasklistsmall actionList={otherActions} /> : <></>)
                            }
                            {
                                (openStatus ? <TaskStatusList /> : <></>)
                            }

                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-11">
                            {
                                (Comp) ? <Comp action={action} /> : <></>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}